import { render, staticRenderFns } from "./privilege.vue?vue&type=template&id=1f2e981d&"
import script from "./privilege.vue?vue&type=script&lang=js&"
export * from "./privilege.vue?vue&type=script&lang=js&"
import style0 from "./privilege.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports